import { FC } from 'react';

const ProjectTasks: FC<{ projectId: string }> = ({ projectId }) => {
  return <></>;
};

export default ProjectTasks;
